<template>
  <div class="container-fluid p-1 position-relative ">
    <div class="row">
      <div class="d-flex justify-content-between w-100">
        <div class="px-1">
          <router-link
            :to="{ name: 'BatchParticipantsID', params: { id: project } }"
            class="btn bg-gradient-info top-button"
          >
            <i class="bi bi-arrow-left-circle"></i> &nbsp;&nbsp;Back
          </router-link>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div class="card my-4">
        <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2 mb-4">
          <div class="row bg-gradient-info shadow-black border-radius-lg pt-4 pb-3 mb-3">
            <h6 class="col text-white text-capitalize ps-3">Participant ({{ this.data_enrollment_info.student_name }})</h6>
          </div>
          
          <Loading message="Loading datas" :loading = "loading"/>

          <div v-if="loading == false" class="col-lg-20 mb-md-0 mb-4">
            <div class="card">

              <div v-if="showAlertStatus" :class="['alert', responseStatusCode != 200 ? 'alert-danger': 'alert-success', 'alert-dismissible', 'fade', 'show']" role="alert">
                <span class="text-white fw-bold">{{ alertMessage }}</span>
                <button type="button" class="btn-close d-flex align-items-center px-4" data-bs-dismiss="alert" aria-label="Close">
                  <i class="bi bi-x fs-3"></i>
                </button>
              </div>

              <div class="row mx-3 my-3 d-flex flex-row flex-wrap gap-4 justify-content-start">
                <div class="card border border-info col-auto p-2" style="margin-bottom: 1%;">
                  <h6>Project code</h6>
                  <b>{{ this.data_enrollment_info.project_info }}</b>
                </div>
                
                <div class="card border border-info col-auto p-2" style="margin-bottom: 1%;">
                  <h6>Project description</h6>
                  <span v-html="this.data_enrollment_info.project_description"></span>
                </div>

              </div>

              <div class="d-flex justify-content-end gap-2 mx-3 mb-3">
                <button v-if="this.data_enrollment_info.has_active_enrollment" v-bind:title="buttonTitle.changeStatus" class="btn bg-gradient-success my-0 m-1" data-bs-toggle="modal" data-bs-target="#modalChangeEnroll" ><i class="bi bi-toggle2-on fs-6"></i></button>

                <button v-else v-bind:title="buttonTitle.changeStatus" class="btn bg-gradient-warning my-0 m-1" disabled><i class="bi bi-x-circle fs-6"></i></button>

                <button v-bind:title="buttonTitle.block" v-if="this.data_enrollment_info.student_is_blocked == false" data-bs-toggle="modal" data-bs-target="#modalBlockStudent" @click="this.statusBlock = false" class="btn bg-gradient-success my-0 m-1 fs-6"><i class="bi bi-unlock fs-6"></i></button>

                <button v-bind:title="buttonTitle.unlock" v-else data-bs-toggle="modal" data-bs-target="#modalBlockStudent" @click="this.statusBlock = true" class="btn bg-gradient-danger my-0 m-1 fs-6"><i class="bi bi-lock"></i></button>
              </div>
            </div>

            <nav>               
              <div class="nav nav-tabs" id="nav-tab" role="tablist" style="margin-top: 2.5%; margin-bottom: 1%;">
                <button v-if="this.data_enrollment_info.info_lp.length > 0" class="nav-link text-dark font-weight-bold" id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#nav-home" type="button" role="tab" aria-controls="nav-home" aria-selected="true">Inscriptions Info LP</button>

                <button v-if="this.data_enrollment_info.info_bot.length > 0" class="nav-link text-dark font-weight-bold" id="nav-profile-tab" data-bs-toggle="tab" data-bs-target="#nav-profile" type="button" role="tab" aria-controls="nav-profile" aria-selected="false">Inscriptions Info Bot</button>

                <button v-if="this.data_enrollment_info.depositions.length > 0" class="nav-link text-dark font-weight-bold" id="nav-contact-tab" data-bs-toggle="tab" data-bs-target="#nav-contact" type="button" role="tab" aria-controls="nav-contact" aria-selected="false">Depositions</button>

                <button class="nav-link text-dark font-weight-bold" id="nav-lessons-tab" data-bs-toggle="tab" data-bs-target="#nav-lessons" type="button" role="tab" aria-controls="nav-lessons" aria-selected="false">Lessons</button>

                <button class="nav-link text-dark font-weight-bold" id="nav-pills-tab" data-bs-toggle="tab" data-bs-target="#nav-pills" type="button" role="tab" aria-controls="nav-pills" aria-selected="false">Pills</button>

                <button class="nav-link text-dark font-weight-bold" id="nav-command-tree-tab" data-bs-toggle="tab" data-bs-target="#nav-command-tree" type="button" role="tab" aria-controls="nav-command-tree" aria-selected="false">Command Logs</button>
              </div>
            </nav>

            <div class="tab-content" id="nav-tabContent">                
              <div class="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab" tabindex="0">
                <div v-if="data_enrollment_info.info_lp.length > 0" class="card d-flex flex-row flex-wrap justify-content-start gap-3 my-3 p-3 border border-secondary">                    
                  <div v-for="data_lp in data_enrollment_info.info_lp" :key="data_lp.field_name" class="w-30 m-0 p-0">
                    <div class="form-group">
                      <label class="form-label fs-6">{{ data_lp.field_name }}</label>

                      <input type="text" :value="data_lp.response_data" class="card px-3 form-control border text-secondary fs-6 bg-white" readonly>
                    </div>
                  </div>
                </div>
              </div>

              <div class="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab" tabindex="0">
                <div v-if="data_enrollment_info.info_bot.length > 0" class="card d-flex flex-row flex-wrap justify-content-start gap-3 my-3 p-3 border border-secondary">                    
                  <div v-for="data_bot in data_enrollment_info.info_bot" :key="data_bot.field_name" class="w-30 m-0 p-0">
                    <div class="form-group">
                      <label class="form-label fs-6">{{data_bot.fild_name}}</label>

                      <input type="text" :value="data_bot.response_data" class="col card px-3 form-control border text-secondary fs-6 bg-white" readonly>
                    </div>
                  </div>
                </div>
              </div>

              <div class="tab-pane fade" id="nav-contact" role="tabpanel" aria-labelledby="nav-contact-tab" tabindex="0">
                <div class="accordion-1">
                  <div class="container">                      
                    <div class="row">
                      <div class="col-md-10 mx-auto">
                        <div v-for="data_depositions in data_enrollment_info.depositions" :key="data_depositions.id" class="accordion" :id="'accordionDep'+data_depositions.id">
                          <div class="accordion-item mb-3">
                            <h5 class="accordion-header" id="headingOne">
                              <button class="accordion-button border-bottom font-weight-bold collapsed" type="button" data-bs-toggle="collapse" :data-bs-target="'#collapseOne'+data_depositions.id" aria-expanded="false" :aria-controls="'collapseOne'+data_depositions.id">
                                {{data_depositions.lesson_reference}}
                                <i class="collapse-close fa fa-plus text-xs pt-1 position-absolute end-0 me-3" aria-hidden="true"></i>
                                <i class="collapse-open fa fa-minus text-xs pt-1 position-absolute end-0 me-3" aria-hidden="true"></i>
                              </button>
                            </h5>

                            <div :id="'collapseOne'+data_depositions.id" class="accordion-collapse collapse" aria-labelledby="headingOne" :data-bs-parent="'#accordionDep'+data_depositions.id" style="">
                              <div class="accordion-body text-sm opacity-8">
                                <div class="d-flex justify-content-center align-items-center gap-3">
                                  <div class="d-flex justify-content-center card border border-secondary p-3">
                                    <div class="card-header text-center">
                                      <h6>Score</h6>
                                    </div>

                                    <div class="card-body text-center fs-6">
                                      <div v-if="data_depositions.score == 1">
                                        <i class="bi bi-star-fill" style="color: maroon;"></i>
                                      </div>

                                      <div v-if="data_depositions.score == 2">
                                        <i class="bi bi-star-fill" style="color: maroon;"></i>
                                        <i class="bi bi-star-fill" style="color: darkred;"></i>        
                                      </div>

                                      <div v-if="data_depositions.score == 3">
                                        <i class="bi bi-star-fill" style="color: maroon;"></i>
                                        <i class="bi bi-star-fill" style="color: darkred;"></i>
                                        <i class="bi bi-star-fill" style="color: sienna;"></i>
                                      </div>

                                      <div v-if="data_depositions.score == 4">
                                        <i class="bi bi-star-fill" style="color: maroon;"></i>
                                        <i class="bi bi-star-fill" style="color: darkred;"></i>
                                        <i class="bi bi-star-fill" style="color: sienna;"></i>
                                        <i class="bi bi-star-fill" style="color: orange"></i>
                                      </div>

                                      <div v-if="data_depositions.score == 5">
                                        <i class="bi bi-star-fill" style="color: maroon;"></i>
                                        <i class="bi bi-star-fill" style="color: darkred;"></i>
                                        <i class="bi bi-star-fill" style="color: sienna;"></i>
                                        <i class="bi bi-star-fill" style="color: orange"></i>
                                        <b><i class="bi bi-star-fill" style="color: gold;"></i></b>
                                      </div>
                                    </div>
                                  </div>

                                  <div class="d-flex justify-content-center card border border-secondary p-3">
                                    <div class="card-header text-center">
                                      <h6>Deposition</h6>
                                    </div>
                                    <div class="card-body text-center">                                        
                                      <b class="fs-6 text-center">{{data_depositions.text_deposition}}</b>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <div class="tab-pane fade" id="nav-lessons" role="tabpanel" aria-labelledby="nav-lessons-tab" tabindex="0">
                <div v-if="data_enrollment_info.lessons_by_course && Object.keys(data_enrollment_info.lessons_by_course).length > 0" class="d-flex flex-column gap-4 my-3">
                  <div v-for="courseData in data_enrollment_info.lessons_by_course" :key="courseData.course_id" class="card border border-info" style="overflow: hidden;">
                    <div class="p-3 bg-info text-white">
                      <div class="d-flex justify-content-between align-items-center">
                        <div class="d-flex align-items-center gap-3">
                          <h5 class="mb-0 text-white font-weight-bold">{{ courseData.course_name }}</h5>
                        </div>
                        
                        <div>
                          <button class="btn btn-sm btn-light text-dark" type="button" data-bs-toggle="collapse" :data-bs-target="'#courseDetails' + courseData.course_id" aria-expanded="false" :aria-controls="'courseDetails' + courseData.course_id">
                            <i class="bi bi-book me-2"></i>
                            {{ courseData.lessons.length }} lesson{{ courseData.lessons.length !== 1 ? 's' : '' }}
                          </button>
                        </div>
                      </div>
                    </div>
                    
                    <div :id="'courseDetails' + courseData.course_id" class="collapse">
                      <div class="p-3">
                        <div class="d-flex flex-column gap-3">
                          <div v-for="lesson in courseData.lessons" :key="lesson.lesson_id" class="card border border-light">
                            <div class="p-3" style="background-color: #f8f9fa; border-bottom: 1px solid #dee2e6;">
                              <div class="d-flex justify-content-between align-items-center">
                                <div class="d-flex align-items-center gap-3">
                                  <span class="badge text-sm px-3 py-2"
                                        :class="{
                                          'bg-success': lesson.is_completed,
                                          'bg-secondary': !lesson.is_completed
                                        }">
                                    {{ lesson.is_completed ? 'Completed' : 'Not Started' }}
                                  </span>
                                  
                                  <h6 class="mb-0 text-dark font-weight-bold">
                                    {{ lesson.lesson_order_id }}. {{ lesson.lesson_name }}
                                  </h6>
                                  
                                  <small v-if="lesson.lesson_progress_created" class="text-muted">
                                    <i class="bi bi-calendar3 me-1"></i>
                                    {{ formatDate(lesson.lesson_progress_created) }}
                                  </small>
                                </div>
                                
                                <div v-if="lesson.responses && lesson.responses.length > 0">
                                  <button class="btn btn-sm bg-gradient-info" type="button" data-bs-toggle="collapse" :data-bs-target="'#lessonResponses' + lesson.lesson_id" aria-expanded="false" :aria-controls="'lessonResponses' + lesson.lesson_id">
                                    <i class="bi bi-question-circle me-2"></i>
                                    {{ lesson.responses.length }} response{{ lesson.responses.length !== 1 ? 's' : '' }}
                                  </button>
                                </div>
                              </div>
                            </div>
                            
                            <div v-if="lesson.responses && lesson.responses.length > 0" :id="'lessonResponses' + lesson.lesson_id" class="collapse">
                              <div class="p-3">
                                <h6 class="text-dark font-weight-bold mb-3">
                                  <i class="bi bi-chat-square-text me-2"></i>Questions & Answers:
                                </h6>
                                <div class="d-flex flex-column gap-3">
                                  <div v-for="response in lesson.responses" :key="response.question_id" class="card border border-light bg-light">
                                    <div class="card-body">
                                      <div class="mb-3">
                                        <h6 class="font-weight-bold mb-2">
                                          <i class="bi bi-patch-question me-2"></i>Question:
                                        </h6>
                                        <div class="ms-4" v-html="response.question_text"></div>
                                      </div>
                                      
                                      <div class="mb-3">
                                        <h6 class="text-dark font-weight-bold mb-2">
                                          <i class="bi bi-chat-left-text me-2"></i>Answer:
                                        </h6>
                                        <div class="ms-4">
                                          <p class="mb-2" v-if="response.answer_text">{{ response.answer_text }}</p>
                                        </div>
                                      </div>
                                      
                                      <div class="d-flex justify-content-between align-items-center">
                                        <span class="badge text-sm px-3 py-2"
                                              :class="{
                                                'bg-success': response.is_correct,
                                                'bg-danger': !response.is_correct
                                              }">
                                          {{ response.is_correct ? 'Correct' : 'Incorrect' }}
                                        </span>
                                        <small class="text-muted">
                                          <i class="bi bi-clock me-1"></i>
                                          {{ formatDate(response.created) }}
                                        </small>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div v-else class="card border border-secondary my-3">
                  <div class="card-body text-center text-muted py-5">
                    <i class="bi bi-book text-muted" style="font-size: 3rem;"></i>
                    <h5 class="text-muted mt-3">No lesson data available</h5>
                    <p class="text-muted">This participant hasn't started any lessons yet.</p>
                  </div>
                </div>
              </div>
              
              <div class="tab-pane fade" id="nav-pills" role="tabpanel" aria-labelledby="nav-pills-tab" tabindex="0">
                <div v-if="data_enrollment_info.pill_registrations.length > 0" class="d-flex flex-column gap-3 my-3">
                  <div v-for="data_pill in data_enrollment_info.pill_registrations" :key="data_pill.id" class="card border border-secondary" style="overflow: hidden;">
                    <div class="p-3" style="background-color: #f8f9fa; border-bottom: 1px solid #dee2e6;">
                      <div class="d-flex justify-content-between align-items-center">
                        <div class="d-flex align-items-center gap-3">
                          <span class="badge text-sm px-3 py-2"
                                :class="{
                                  'bg-success': data_pill.pill_status.toLowerCase().includes('clicked') || data_pill.pill_status.toLowerCase().includes('answered'),
                                  'bg-warning': data_pill.pill_status.toLowerCase().includes('waiting') || data_pill.pill_status.toLowerCase().includes('sent'),
                                }">
                            {{ data_pill.pill_status }}
                          </span>

                          <h6 class="mb-0 text-dark font-weight-bold">{{ data_pill.pill_name }}</h6>

                          <span>{{ formatDate(data_pill.created) }}</span>
                        </div>
                        
                        <div v-if="data_pill.answers && data_pill.answers.length > 0">
                          <button class="btn btn-sm bg-gradient-info" type="button" data-bs-toggle="collapse" :data-bs-target="'#pillAnswers' + data_pill.id" aria-expanded="false" :aria-controls="'pillAnswers' + data_pill.id">
                            <i class="bi bi-chat-text me-2"></i>
                            {{ data_pill.answers.length }} answer{{ data_pill.answers.length !== 1 ? 's' : '' }}
                          </button>
                        </div>
                      </div>
                    </div>
                    
                    <div v-if="data_pill.answers && data_pill.answers.length > 0" :id="'pillAnswers' + data_pill.id" class="collapse">
                      <div class="p-3">
                        <h6 class="text-dark font-weight-bold mb-3">
                          <i class="bi bi-chat-dots me-2"></i>Answers:
                        </h6>
                        <div class="d-flex flex-column gap-2">
                          <div v-for="answer in data_pill.answers" :key="answer.id" class="card border border-light p-3 bg-light">
                            <div class="d-flex justify-content-between align-items-start">
                              <div class="flex-grow-1">
                                <div v-if="answer.question" class="mb-3">
                                  <h6 class="font-weight-bold mb-2">
                                    <i class="bi bi-question-circle me-2"></i>{{ answer.question }}
                                  </h6>
                                </div>
                                <div class="mb-2">
                                  <span class="text-muted text-sm">Answer:</span>
                                  <p class="mb-0 text-dark ms-2">{{ answer.data }}</p>
                                </div>
                                <small class="text-muted">
                                  <i class="bi bi-clock me-1"></i>
                                  {{ formatDate(answer.created) }}
                                </small>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class="card border border-secondary my-3">
                  <div class="card-body text-center text-muted py-5">
                    <i class="bi bi-capsule text-muted" style="font-size: 3rem;"></i>
                    <h5 class="text-muted mt-3">No pill data available</h5>
                    <p class="text-muted">This participant has no pill interactions yet.</p>
                  </div>
                </div>
              </div>

              <div class="tab-pane fade" id="nav-command-tree" role="tabpanel" aria-labelledby="nav-command-tree-tab" tabindex="0">
                <div v-if="data_enrollment_info.custom_commands_logs.length > 0" class="d-flex flex-column gap-3 my-3">
                  <div v-for="(command_log, index) in data_enrollment_info.custom_commands_logs" :key="index" class="card border border-secondary" style="overflow: hidden;">
                    <div class="p-3" style="background-color: #f8f9fa; border-bottom: 1px solid #dee2e6;">
                      <div class="d-flex justify-content-between align-items-center">
                        <div class="d-flex align-items-center gap-3">
                          <span class="badge text-sm px-3 py-2"
                                :class="{
                                  'bg-info': command_log.is_main_command === true,
                                  'bg-success': command_log.is_main_command === false
                                }">
                            {{ command_log.is_main_command ? 'Main Command' : 'Command' }}
                          </span>

                          <h6 class="mb-0 text-dark font-weight-bold">#{{ command_log.command_tag }}</h6>

                          <span class="text-md px-2 py-1">
                            {{ command_log.number_of_consultations }} consultation{{ command_log.number_of_consultations !== 1 ? 's' : '' }}
                          </span>
                        </div>
                        
                        <div v-if="command_log.values && command_log.values.length > 0">
                          <button class="btn btn-sm bg-gradient-secondary" type="button" data-bs-toggle="collapse" :data-bs-target="'#commandDetails' + index" aria-expanded="false" :aria-controls="'commandDetails' + index">
                            <i class="bi bi-calendar3 me-2"></i>
                            View Daily Totals
                          </button>
                        </div>
                      </div>
                    </div>
                    
                    <div v-if="command_log.values && command_log.values.length > 0" :id="'commandDetails' + index" class="collapse">
                      <div class="p-3">
                        <h6 class="text-dark font-weight-bold mb-3">
                          <i class="bi bi-clock-history me-2"></i>Command consultations per day:
                        </h6>
                        <div class="d-flex flex-column gap-2">
                          <div v-for="value in command_log.values" :key="value.created" class="card border border-light p-3 bg-light">
                            <div class="d-flex justify-content-between align-items-center flex-wrap gap-2">
                              <span class="badge bg-gradient-info text-xs">
                                <i class="bi bi-calendar3 me-1"></i>
                                {{ formatDate(value.created, false) }}
                              </span>
                              <span class="text-md px-2 py-1 text-muted">
                                {{ value.total }} consultation{{ value.total !== 1 ? 's' : '' }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class="card border border-secondary my-3">
                  <div class="card-body text-center text-muted py-5">
                    <i class="bi bi-info-circle text-muted" style="font-size: 3rem;"></i>
                    <h5 class="text-muted mt-3">No command consultations available</h5>
                    <p class="text-muted">This participant has no command consultations recorded yet.</p>
                  </div>
                </div>
              </div>
              
            </div>                    
          </div>                    
        </div>

        <LastUpdateInfo />
      </div>
    </div>
  </div>

  <!-- modal change enroll -->
  <div class="modal" id="modalChangeEnroll" tabindex="-1" aria-labelledby="modalChangeEnrollLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="modalChangeEnrollLabel">Deactivate Active Enrollment</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <h7>Change the status of the participant?</h7>
            <div class="mt-2">
              <label for="subscriptions_deadline" class="form-label">Do you want a specific date to change the status to deactivated?<br>(UTC-3)</label>                    
              <div class="input-group input-group-outline">                      
                <input id="subscriptions_deadline" type="date" placeholder="dd/mm/yyyy" class="form-control form-control-default" v-model="this.deadline" name="subscriptions_deadline">
              </div>
              <div class="input-group input-group-outline mt-2">
                <small v-if=" this.deadline == null" for="subscriptions_deadline" class="text-danger">If you save without a date, it will change the status now.</small>                        
                <small v-else for="subscriptions_deadline" class="text-danger" >Actual deadline: {{ this.deadline }}</small>                     
              </div>
              
            </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn bg-gradient-danger" data-bs-dismiss="modal" @click="clearStatus()">Close</button>
            <button type="button" class="btn bg-gradient-success" @click="changeStatus()">Confirm status change</button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal block student -->
  <div class="modal fade" id="modalBlockStudent" tabindex="-1" aria-labelledby="modalBlockStudentLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="modalBlockStudentLabel">{{ this.statusBlock == true ? 'Unblock' : 'Block' }} Student</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div v-if=" this.statusBlock == false" class="modal-body text-center" >
          <div class="input-group input-group-outline">
            <h6>Do you want to block the student?</h6>
            <small class="text-danger" >Blocked students will lose all access to the courses on offer.</small> 
          </div>
        </div>
        <div v-else class="modal-body text-center" >
          <div v-if=" this.statusBlock == true" class="input-group input-group-outline">                  
            <h6> Do you want to unblock the student?</h6>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn bg-gradient-danger" data-bs-dismiss="modal">Close</button>
          <button type="button" class="btn bg-gradient-success" @click="blockStudent()">
            {{ this.statusBlock == true ? 'unblock' :  'block' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { http } from "../http/index";
  import lysLogo from "@/assets/img/icon-lys.png";
  import MaterialButton from "@/components/MaterialButton.vue";
  import Loading from "@/views/components/Loading.vue";
  import MiniStatisticsCard from "./components/MiniStatisticsCard.vue";
  import LastUpdateInfo from "./components/LastUpdateInfo.vue";

  export default {
    name: "ControUsers",

    components : {
      Loading,
      MaterialButton,
      LastUpdateInfo,
      MiniStatisticsCard,
    },

    data() {
      return {
        lysLogo,
        loading: true,
        project: this.$route.params.project_id,
        token_user: localStorage.getItem("token"),
        student_id: this.$route.params.id,
        data_enrollment_info: {
          student_name: "",
        },

        buttonTitle:{
          info: "Info student",
          block: "Block student?",
          unlock: "Unblocking student?",
          changeStatus: "Change status"
        },

        alertMessage: "",
        showAlertStatus: false,
        responseStatusCode: "",

        statusBlock: null,
        deadline:null,
      };
    },

    mounted() {
      this.enrollmentFormClient();
    },

    methods: {
      formatDate(date, time = true) {
        if (!date) {
          return "--";
        }

        if (typeof date === "string") {
          const trimmed = date.trim();
          const isDateOnly = /^\d{4}-\d{2}-\d{2}$/.test(trimmed);

          if (isDateOnly) {
            const [year, month, day] = trimmed.split("-");
            if (!time) {
              return `${day}/${month}/${year}`;
            }
            return `${day}/${month}/${year} 00:00:00`;
          }
        }

        const dateObj = new Date(date);

        if (Number.isNaN(dateObj.getTime())) {
          return date;
        }

        const day = dateObj.getDate().toString().padStart(2, "0");
        const month = (dateObj.getMonth() + 1).toString().padStart(2, "0");
        const year = dateObj.getFullYear();
        const hours = dateObj.getHours().toString().padStart(2, "0");
        const minutes = dateObj.getMinutes().toString().padStart(2, "0");
        const seconds = dateObj.getSeconds().toString().padStart(2, "0");
        
        if (!time) {
          return `${day}/${month}/${year}`;
        } else {
          return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
        }
      },

      enrollmentFormClient() {
        let payload = {
          token_user: this.token_user,
          project_id: this.project,
          student_id: this.student_id,
        }
        
        http.post('/api/v1/dashboard/select-enrollment-from-client/', payload)
        .then((response) => {
          this.data_enrollment_info = response.data.info_enrollments
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
      },

      blockStudent(){
        let payload = {
          token_user: this.token_user,
          student_id: this.student_id,
          blocked_status: this.statusBlock
        }

        http.post('/api/v1/dashboard/block_student/', payload)
        .then((response) => {
          this.showAlertStatus = true
          this.responseStatusCode = response.status
          this.alertMessage = "Student blocked successfully."
        })
        .catch((error) => {
          this.showAlertStatus = true
          this.showAlertStatus = true;
          if (error.response && error.response.status === 422) {
            this.alertMessage = "This student has been blocked for violating the platform's guidelines, please contact support.";
          } else {
            this.alertMessage = "Error on blocking the student.";
            this.responseStatusCode = error.response ? error.response.status : 'unknown';
          }
        })
        .finally(() => {
          this.enrollment_id = null
          this.statusBlock = null
          $('#modalBlockStudent').modal('hide')
          
          setTimeout(() => {
            this.showAlertStatus = false
            this.loading = true
            this.enrollmentFormClient()
          }, 3500)
        })
      },

      clearStatus(){
        this.deadline = null
      },

      async changeStatus(){
        let payload = {
          token_user: this.token_user,
          project_id: this.project,
          student_id: this.student_id,
          deadline: this.deadline ? this.deadline : undefined
        }

        http.post('/api/v1/dashboard/change-status-enrollment/', payload)
        .then((response) => {
          this.showAlertStatus = true
          this.responseStatusCode = response.status
          this.alertMessage = "Enrollment status changed successfully."
        })
        .catch((error) => {
          this.showAlertStatus = true
          this.alertMessage = "Error changing the status of the participant."
          this.responseStatusCode = error.status
        })
        .finally(() => {
          $('#modalChangeEnroll').modal('hide')
          this.deadline = null
          setTimeout(() => {
            this.showAlertStatus = false
            this.loading = true
            this.enrollmentFormClient()
          }, 3500)
        })
      },
    }
  }
</script>

<style scoped>
</style>
